import { helper } from '@/utils'
import config from '@/config'
import ThemeLegal from '../ThemeLegal/ThemeLegal.vue'
import ThemeView from '../ThemeView/ThemeView.vue'

export default {
  components: { ThemeLegal, ThemeView },
  computed: {
    componentTitle () {
      return this.$t(`ComponentTitle.${this.$route.name}`)
    },
    tabValue () {
      return this.$route.params.id || 'general'
    }
  },
  methods: {
    getTheme () {
      this.loading = true
      // TODO: Make sure there has no conflict keys when do the Object.assign()
      return Promise.all([
        this.$api.getTheme(),
        this.$api.getLegal(),
        this.$api.getServiceConfig({ service: 'email' })
      ])
        .then(([themeData, legalData, serviceConfigData]) => {
          const config = Object.assign({}, themeData.data, legalData.data, serviceConfigData.data)

          Object.keys(this.$data.fieldsData).forEach(blockKey => {
            const obj = this.$data.fieldsData[blockKey]
            for (let key in obj) {
              const input = obj[key]
              const value = config[key]

              if (value) input.model = value
            }
          })

          this.loading = false
          return config
        })
        .catch((error) =>
          helper.showErrorMessage(this, this.component, error)
        )
    },
    getImageSrc (id) {
      let ts = Date.now()
      return `${config.serverURI}/theme/${id}?${ts}`
    },
    setUrl (tab) {
      this.$router.push({ path: `/theme/${tab.name}` })
    }
  },
  data () {
    return {
      component: 'theme',
      fieldsData: {
        appText: {
          wifi_name: {
            class: 'form-control',
            description: 'themeTabAppAppTextWifiNameDescription',
            label: 'themeTabAppAppTextWifiNameLabel',
            model: null,
            validate: {
              rules: {
                max: 32
              }
            }
          },
          news: {
            class: 'form-control',
            description: 'themeTabAppAppTextNewsDescription',
            label: 'themeTabAppAppTextNewsLabel',
            model: null,
            type: 'textarea'
          }
        },
        appFile: {
          'logo_navbar.png': {
            currentImgSrc: this.getImageSrc('logo_navbar.png'),
            description: 'themeTabAppAppFileNavbarDescription',
            isLocal: false,
            label: 'themeTabAppAppFileNavbarLabel',
            name: 'logo_navbar.png',
            selectedFileName: ''
          }
        },
        settingsText: {
          product_name: {
            class: 'form-control',
            description: 'themeTabGeneralSettingsTextProductNameDescription',
            label: 'themeTabGeneralSettingsTextProductNameLabel',
            model: null,
            placeholder: 'themeTabGeneralSettingsTextProductNamePlaceholder',
            validate: {}
          },
          primary_color: {
            class: 'form-control',
            description: 'themeTabGeneralSettingsTextPrimaryColorDescription',
            label: 'themeTabGeneralSettingsTextPrimaryColorLabel',
            model: null,
            placeholder: 'themeTabGeneralSettingsTextPrimaryColorPlaceholder',
            type: 'colorpicker',
            validate: {
              rules: {
                required: true
              }
            }
          }
        },
        settingsFile: {
          'logo.png': {
            currentImgSrc: this.getImageSrc('logo.png'),
            description: 'themeTabGeneralSettingsFileDescription',
            isLocal: false,
            label: 'themeTabGeneralSettingsFileLabel',
            name: 'logo.png',
            selectedFileName: ''
          }
        },
        emailBasicText: {
          company_name: {
            class: 'form-control',
            description: 'themeTabEmailEmailBasicTextCompanyNameDescription',
            label: 'themeTabEmailEmailBasicTextCompanyNameLabel',
            model: null,
            placeholder: 'themeTabEmailEmailBasicTextCompanyNamePlaceholder',
            validate: {}
          },
          company_url: {
            class: 'form-control',
            description: 'themeTabEmailEmailBasicTextCompanyUrlDescription',
            label: 'themeTabEmailEmailBasicTextCompanyUrlLabel',
            model: null,
            placeholder: 'themeTabEmailEmailBasicTextCompanyUrlPlaceholder',
            validate: {}
          },
          company_address: {
            class: 'form-control',
            description: 'themeTabEmailEmailBasicTextCompanyAddressDescription',
            label: 'themeTabEmailEmailBasicTextCompanyAddressLabel',
            model: null,
            placeholder: 'themeTabEmailEmailBasicTextCompanyAddressPlaceholder',
            validate: {}
          },
          company_contact: {
            class: 'form-control',
            description: 'themeTabEmailEmailBasicTextCompanyContactDescription',
            label: 'themeTabEmailEmailBasicTextCompanyContactLabel',
            model: null,
            placeholder: 'themeTabEmailEmailBasicTextCompanyContactPlaceholder',
            validate: {}
          },
          apple_store: {
            class: 'form-control',
            description: 'themeTabEmailEmailBasicTextAppleStoreDescription',
            label: 'themeTabEmailEmailBasicTextAppleStoreLabel',
            model: null,
            placeholder: 'themeTabEmailEmailBasicTextAppleStorePlaceholder',
            validate: {}
          },
          google_play: {
            class: 'form-control',
            description: 'themeTabEmailEmailBasicTextGooglePlayDescription',
            label: 'themeTabEmailEmailBasicTextGooglePlayLabel',
            model: null,
            placeholder: 'themeTabEmailEmailBasicTextGooglePlayPlaceholder',
            validate: {}
          },
          app_name: {
            class: 'form-control',
            description: 'themeTabEmailEmailBasicTextAppNameDescription',
            label: 'themeTabEmailEmailBasicTextAppNameLabel',
            model: null,
            placeholder: 'themeTabEmailEmailBasicTextAppNamePlaceholder',
            validate: {}
          },
          app_url_scheme: {
            class: 'form-control',
            description: 'themeTabEmailEmailBasicTextAppUrlSchemeDescription',
            label: 'themeTabEmailEmailBasicTextAppUrlSchemeLabel',
            model: null,
            placeholder: 'themeTabEmailEmailBasicTextAppUrlSchemePlaceholder',
            validate: {}
          },
          support_email_account: {
            class: 'form-control',
            description: 'themeTabEmailEmailBasicTextSupportEmailAccountDescription',
            label: 'themeTabEmailEmailBasicTextSupportEmailAccountLabel',
            model: null,
            placeholder: 'themeTabEmailEmailBasicTextSupportEmailAccountPlaceholder',
            validate: {}
          }
        },
        emailTemplateText: {
          welcome_email_subject: {
            class: 'form-control',
            label: 'themeTabEmailEmailTemplateTextWelcomeEmailSubjectLabel',
            model: null,
            placeholder: 'themeTabEmailEmailTemplateTextWelcomeEmailSubjectPlaceholder',
            validate: {}
          },
          welcome_email_headline: {
            class: 'form-control',
            label: 'themeTabEmailEmailTemplateTextWelcomeEmailHeadlineLabel',
            model: null,
            placeholder: 'themeTabEmailEmailTemplateTextWelcomeEmailHeadlinePlaceholder',
            validate: {}
          },
          welcome_email_body: {
            class: 'form-control',
            label: 'themeTabEmailEmailTemplateTextWelcomeEmailBodyLabel',
            model: null,
            placeholder: 'themeTabEmailEmailTemplateTextWelcomeEmailBodyPlaceholder',
            validate: {}
          },
          welcome_web_headline: {
            class: 'form-control',
            label: 'themeTabEmailEmailTemplateTextWelcomeWebHeadlineLabel',
            model: null,
            placeholder: 'themeTabEmailEmailTemplateTextWelcomeWebHeadlinePlaceholder',
            validate: {}
          },
          welcome_web_body: {
            class: 'form-control',
            label: 'themeTabEmailEmailTemplateTextWelcomeWebBodyLabel',
            model: null,
            placeholder: 'themeTabEmailEmailTemplateTextWelcomeWebBodyPlaceholder',
            validate: {}
          }
        },
        ClaimDevicesTemplateText: {
          claim_web_headline: {
            class: 'form-control',
            label: 'themeTabEmailClaimDevicesTemplateTextClaimDeviceTitleLabel',
            model: null,
            placeholder: 'themeTabEmailClaimDevicesTemplateTextClaimDeviceTitlePlaceholder',
            validate: {}
          },
          claim_web_body: {
            class: 'form-control',
            label: 'themeTabEmailClaimDevicesTemplateTextClaimDeviceBodyLabel',
            model: null,
            placeholder: 'themeTabEmailClaimDevicesTemplateTexttClaimDeviceBodyPlaceholder',
            type: 'textarea',
            validate: {}
          }
        },
        emailSenderText: {
          connection_server: {
            class: 'form-control',
            label: 'themeTabEmailEmailSenderTextConnectionServerLabel',
            model: null,
            placeholder: 'themeTabEmailEmailSenderTextConnectionServerPlaceholder',
            validate: {}
          },
          connection_user: {
            class: 'form-control',
            label: 'themeTabEmailEmailSenderTextConnectionUserLabel',
            model: null,
            placeholder: 'themeTabEmailEmailSenderTextConnectionUserPlaceholder',
            validate: { regex: /^[^\s-]+$/ }
          },
          connection_password: {
            class: 'form-control',
            label: 'themeTabEmailEmailSenderTextConnectionPasswordLabel',
            model: null,
            placeholder: 'themeTabEmailEmailSenderTextConnectionPasswordPlaceholder',
            type: 'password',
            validate: { regex: /^[^\t\r\n\f-]*$/, required: true }
          },
          connection_scheme: {
            class: 'form-control',
            label: 'themeTabEmailEmailSenderTextConnectionSchemeLabel',
            model: null,
            placeholder: 'themeTabEmailEmailSenderTextConnectionSchemePlaceholder',
            validate: { regex: /(smtp|smtps)$/ }
          },
          connection_port: {
            class: 'form-control',
            label: 'themeTabEmailEmailSenderTextConnectionPortLabel',
            model: null,
            placeholder: 'themeTabEmailEmailSenderTextConnectionPortPlaceholder',
            type: 'number',
            validate: 'numeric'
          }
        },
        legalPoliciesText: {
          title: {
            class: 'form-control',
            description: 'themeTabLegalLegalPoliciesTextTitleDescription',
            label: 'themeTabLegalLegalPoliciesTextTitleLabel',
            model: null,
            placeholder: 'themeTabLegalLegalPoliciesTextTitlePlaceholder',
            type: 'text',
            validate: { required: true }
          },
          body: {
            class: 'form-control',
            description: 'themeTabLegalLegalPoliciesTextBodyDescription',
            label: 'themeTabLegalLegalPoliciesTextBodyLabel',
            model: null,
            type: 'textarea',
            validate: { required: true }
          }
        }
      },
      muranoTermsUrl: `https://exosite.com/murano-terms-conditions/`,
      legalUrl: `${window.location.origin}/#/legal`,
      loading: true
    }
  },
  mounted () {
    return this.getTheme()
  }
}



// WEBPACK FOOTER //
// ./src/components/Theme/Theme.js